import React from 'react';
import { ChromePicker } from 'react-color';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
  customPosition: {
    left: '12px',
    top: '53px',
    zIndex: '2'
  },
  fixedBackdrop: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px'
  }
});

const ColorPickerDialog = ({
  value,
  onClick,
  onChange
}) => {
  const classes = useStyles();

  const handleChangeColor = (color) => {
    if (color.rgb.a != 1) {
      const rgbaString = `rgba(
        ${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a}
      )`;
      onChange(rgbaString);
    } else {
      onChange(color.hex);
    }
  };

  return (
    <div className={`absolute ${classes.customPosition}`}>
      <div
        className={classes.fixedBackdrop}
        onClick={onClick}
      />
      <ChromePicker
        color={value}
        onChange={(color) => handleChangeColor(color)}
      />
    </div>
  );
};

export default ColorPickerDialog;
